import { render, staticRenderFns } from "./MenuEditForm.vue?vue&type=template&id=44bd1954&lang=html&"
import script from "./MenuEditForm.vue?vue&type=script&lang=js&"
export * from "./MenuEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports